import { useMemo } from "react";
import { ViewBooking } from "collins-js-sdk";

export const useBookingSearch = (
  sortedBookings: ViewBooking[],
  searchQuery: string
): ViewBooking[] => {
  return useMemo(() => {
    if (!searchQuery.trim()) return sortedBookings;

    const query = searchQuery.toLowerCase();
    // Filter out rejected, no-show, and left bookings from search results
    const nonRejectedBookings = sortedBookings.filter(
      (b) =>
        b.status !== "rejected" &&
        b.currentStage !== "no-show" &&
        b.currentStage !== "left"
    );

    return nonRejectedBookings.filter((booking) => {
      const customerName =
        `${booking.firstName ?? ""} ${booking.lastName ?? ""}`.toLowerCase();
      const phone = (
        typeof booking.phone === "string"
          ? booking.phone
          : String(booking.phone ?? "")
      ).toLowerCase();
      const email = (
        typeof booking.email === "string"
          ? booking.email
          : String(booking.email ?? "")
      ).toLowerCase();
      const reference = String(booking.reference ?? "").toLowerCase();
      const notes = (
        typeof booking.notes === "string"
          ? booking.notes
          : String(booking.notes ?? "")
      ).toLowerCase();

      return (
        customerName.includes(query) ||
        phone.includes(query) ||
        email.includes(query) ||
        reference.includes(query) ||
        notes.includes(query)
      );
    });
  }, [sortedBookings, searchQuery]);
};
